import commentDark from "./comment_icon_dark_14px.png";
import commentLight from "./comment_icon_light_14px.png";
import commentRed from "./comment_icon_red_24px.png";
import commentRedGreen from "./comment_icon_redgreen_24px.png";

type CommentIconProps = {
  color?: "light" | "dark" | "red" | "redgreen";
};

const COMMENT_IMAGES: Record<"light" | "dark" | "red" | "redgreen", string> = {
  light: commentLight,
  dark: commentDark,
  red: commentRed,
  redgreen: commentRedGreen
};

export const CommentIcon = ({ color }: CommentIconProps) => (
  <img src={COMMENT_IMAGES[color || "light"]} alt="Comment icon" height={(color === "red" || color === "redgreen") ? 24 : 14} />
);
